import React from 'react';
import { HelpCircleIcon, HourglassIcon, LayersIcon, TrendingDownIcon, UsersIcon, WalletIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { problems } from '../data/content';
const icons = {
  hourglass: HourglassIcon,
  'trending-down': TrendingDownIcon,
  users: UsersIcon,
  wallet: WalletIcon,
  help: HelpCircleIcon,
  layers: LayersIcon
};
export function Problems() {
  return <section className="w-full bg-cream px-5 py-20 sm:px-8" data-id="element-179" data-mp="2t5e1be54qbcw">
      <div className="mx-auto w-full max-w-5xl" data-id="element-180" data-mp="2o5jd5icqnzvj">
        <div className="mx-auto max-w-2xl text-center" data-id="element-181" data-mp="2o3or20pqe1pv">
          <Reveal data-id="element-182" data-mp="2j5x3fiw4d1rh">
            <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-183" data-mp="2j783b7mg1pdb">
              Känner du igen dig själv i de här situationerna?
            </h2>
          </Reveal>
          <Reveal delay={0.06} data-id="element-184" data-mp="hdsb46apk2g8">
            <p className="mt-5 text-base leading-relaxed text-muted" data-id="element-185" data-mp="he0nzy6tz7rf">
              Om du kan svara ja på någon av dessa — Innebandy Ready är gjord för dig.
            </p>
          </Reveal>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-186" data-mp="34sxzpnav7hxn">
          {problems.map((problem, index) => {
          const Icon = icons[problem.icon as keyof typeof icons];
          return <Reveal as="li" key={problem.text} delay={index % 3 * 0.06} data-id="element-187" data-mp="2vsje0mtzo0tm" data-mpi={index}>
                <div className="flex h-full flex-col rounded-2xl border border-sand bg-white p-6" data-id="element-188" data-mp="2zs1vt9qijvs8">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-level-red/10" data-id="element-189" data-mp="3ni4krgz4slmm">
                    <Icon className="h-5 w-5 text-level-red" aria-hidden="true" data-id="element-190" data-mp="3sijwk43rll2h" />
                  </span>
                  <p className="mt-5 text-[15px] font-semibold leading-relaxed text-navy" data-id="element-191" data-mp="3en8463d306oq">
                    {problem.text}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.12} data-id="element-192" data-mp="f22s5cgi48vf">
          <p className="mx-auto mt-12 max-w-xl text-center font-serif text-2xl italic leading-snug text-level-blue sm:text-3xl" data-id="element-193" data-mp="f2ckh6p0qs4a">
            Och du förtjänar så mycket mer än så.
          </p>
        </Reveal>
      </div>
    </section>;
}